// extracted by mini-css-extract-plugin
module.exports = {"dialpadmain":"numbertyping_dialpadmain__1yw7c","dialnumbers":"numbertyping_dialnumbers__2GQI1","backimg":"numbertyping_backimg__3JjTO","dropitems":"numbertyping_dropitems__19j-H"};